import { h, Ref } from 'vue';
import { inputField } from '@/ui/components/form';
import { Task, useValidation } from '@/ui/concerns';
import { EntityType, validate } from '@/entities/entityType';
import { apiErrorMessage } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';
import EntityTypePropertiesSection from '@/ui/components/entityType/EntityTypePropertiesSection.vue';
import { isEntityPropertiesEnabled } from '@/ui/helpers/featureHelper';
import { EntityTypePropertyForm } from '@/entities/entityTypeProperty';

export function useEntityTypeForm(record: Ref<EntityType>, task: Task) {
  const {
    validationErrors,
    hasNoValidationErrors,
    showValidationErrors,
  } = useValidation(validate, record, task.state);

  const handleSubmit = () => {
    showValidationErrors.value = true;
    if (hasNoValidationErrors.value) {
      task.run();
    }
  };

  const formFields = () => [
    inputField(
      {
        name: 'title',
        label: t('entity-type.title'),
        placeholder: t('entity-type.enter-title'),
        value: record.value.title,
        required: true,
        errors: validationErrors.value,
        disabled: task.state.value.pending,
      },

      value => {
        record.value.title = value;
      },
    ),

    inputField(
      {
        type: 'textarea',
        name: 'description',
        label: t('common.description'),
        placeholder: t('entity-type.enter-description'),
        value: record.value.description,
        required: false,
        errors: validationErrors.value,
        disabled: task.state.value.pending,
      },

      value => {
        record.value.description = value;
      },
    ),

    isEntityPropertiesEnabled()
      ? h(EntityTypePropertiesSection, {
        props: {
          properties: record.value.properties,
          errors: validationErrors.value,
          disabled: task.state.value.pending,
        },
        on: {
          update: (properties: EntityTypePropertyForm[]) => {
            record.value.properties = properties;
          },
        },
      })
      : null,

    apiErrorMessage(task.state.value),
  ];

  return {
    formFields,
    handleSubmit,
  };
}
